import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BackendResponse, entityName } from '@qtek/shared/models';
import { Observable } from 'rxjs';
import { HttpEntityManager } from '../http-entity-manager';

export interface StepperDataPayload {
  stepperName: string;
  step: number;
  jsonData: string;
}

export interface StepperDataResponse {
  jsonData: string;
  step: number;
  stepperName: string;
  userId: string;
}

@Injectable({
  providedIn: 'root',
})
export class StepperDataService extends HttpEntityManager<
  StepperDataResponse,
  StepperDataResponse
> {
  protected entityName: entityName = 'stepperData';

  constructor(protected http: HttpClient) {
    super();
  }

  getStepperData(
    stepperName: string
  ): Observable<BackendResponse<StepperDataResponse>> {
    return this.get(stepperName);
  }

  createStepperData(
    payload: StepperDataPayload
  ): Observable<BackendResponse<StepperDataResponse>> {
    return this.post(payload);
  }

  updateStepperData(
    payload: StepperDataPayload
  ): Observable<BackendResponse<StepperDataResponse>> {
    return this.put(payload);
  }

  deleteStepperData(
    stepperName: string
  ): Observable<BackendResponse<StepperDataResponse>> {
    return this.delete(stepperName);
  }
}
